import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var defaultGetItemAttributes = function defaultGetItemAttributes(item) {
  return item.attributes;
};
export var defaultGetItemDescription = function defaultGetItemDescription(item) {
  return item.description;
};
export var defaultGetItemDisabled = function defaultGetItemDisabled(item) {
  return item.disabled;
};
export var defaultGetItemIcon = function defaultGetItemIcon(item) {
  return item.icon;
};
export var defaultGetItemKey = function defaultGetItemKey(item) {
  return item.key;
};
export var defaultGetItemLabel = function defaultGetItemLabel(item) {
  return item.label;
};
export var defaultGetItemOnClick = function defaultGetItemOnClick(item) {
  return item.onClick;
};
export var defaultGetItemRef = function defaultGetItemRef(item) {
  return item.ref;
};
export var defaultGetItemTagName = function defaultGetItemTagName(item) {
  return item.tagName;
};
export var composePreparedProps = function composePreparedProps(props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    getItemAttributes: props.getItemAttributes || defaultGetItemAttributes,
    getItemDescription: props.getItemDescription || defaultGetItemDescription,
    getItemDisabled: props.getItemDisabled || defaultGetItemDisabled,
    getItemIcon: props.getItemIcon || defaultGetItemIcon,
    getItemKey: props.getItemKey || defaultGetItemKey,
    getItemLabel: props.getItemLabel || defaultGetItemLabel,
    getItemOnClick: props.getItemOnClick || defaultGetItemOnClick,
    getItemRef: props.getItemRef || defaultGetItemRef,
    getItemTagName: props.getItemTagName || defaultGetItemTagName
  });
};
export var getAnimationDirection = function getAnimationDirection(direction) {
  return direction.toLowerCase().includes('up') ? 'up' : 'down';
};